import { render, staticRenderFns } from "./ViewTradeReview.vue?vue&type=template&id=5c31ef87&scoped=true&"
import script from "./ViewTradeReview.vue?vue&type=script&lang=js&"
export * from "./ViewTradeReview.vue?vue&type=script&lang=js&"
import style0 from "./ViewTradeReview.vue?vue&type=style&index=0&id=5c31ef87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c31ef87",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VFlex})
